import BookingCTA from 'components/forms/bookingWidget/BookingCTA';
import styled from 'styled-components';
import { ButtonContainer } from './shared';

interface SubmitBookingWidgetProps {
  isProcessing: boolean;
  isDayAvailable: boolean;
  isInstantBookable?: boolean;
  trackRequestToBookStart: () => void;
  boatId: string;
}
export default ({
  isProcessing,
  isDayAvailable,
  isInstantBookable = false,
  trackRequestToBookStart,
  boatId,
}: SubmitBookingWidgetProps) => (
  <ButtonContainer data-testid="pdp-booking-widget-submit-container">
    <BookingCTA onClick={trackRequestToBookStart} loading={isProcessing} boatId={boatId} disabled={!isDayAvailable} />
    {isInstantBookable && <Text>{chargeCopy}</Text>}
  </ButtonContainer>
);

const chargeCopy = "You won't be charged yet";

const Text = styled.div`
  text-align: center;
  font-size: 12px;
  color: #434c5c;
  padding-top: 12px;
`;
